import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button, Checkbox, FormControlLabel } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateNumber } from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { restructureData } from "../../../../utils/restructureData";
import DynamicStaticTable from "../../../../Components/Common/DynamicStaticTable";
import StaticColumnTable from "../../../../Components/Common/StaticColumnTable";
import { validateLastRow } from "../../../../utils/validateTable";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI305_5 = ({hide}) => {
    const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
const inputData = [
    {
      fieldName: "reductionIntiative",
      title:
        "GHG emissions reduced as a direct result of reduction initiatives, in metric tons of CO2 equivalent.",
      type: "array",
      letter: "a.",
      fields: [
        {
          fieldName: "reductions",
          title: "Reduction initiatives",
          type: "text",
          placeholder: "Enter Text",
          width: "35%",
        },
        {
          fieldName: "value",
          title: "Value",
          type: "number",
          //   options: ["Tonns", "Liters", "M3", "Kg"],
          width: "22%",
          placeholder: "Enter Number",
        },
        {
          fieldName: "unit",
          title: "Unit",
          type: "number",
          width: "22%",
          placeholder: "Type Here",
        },
      ],
    },
  ];

  const inputData1 = [
    {
      fieldName: "gasesIncluded",
      // title: "b. Gases included in the calculation:",
      type: "array",
      letter: "b.",
      fields: [
        {
          fieldName: "gasName",
          title: "Gas Name",
          type: "text",
          placeholder: "Enter Text",
          width: "44%",
        },
        // {
        //   fieldName: "unit",
        //   title: "Unit",
        //   type: "select",
        //   options: ["Tonns", "Liters", "M3", "Kg"],
        //   width: "30%",
        //   placeholder: "Select",
        // },
        {
          fieldName: "total",
          title: "Total Emission",
          type: "number",
          width: "44%",
          placeholder: "Enter Number",
        },
      ],
    },
  ];

  const defaultSegments = ["CO2", "CH4", "N2O", "HFCs", "PFCs", "SF6", "NF3"];

  const seg = [
    "Process redesign",
    "Conversion and retrofitting of equipment",
    "Change in behavior",
    "Operational changes",
    "Fuel changes",
  ];

  const seg2 = seg.map((el) => "tCO2e");

  const questionData = [
    {
      fieldName: "baseYear",
      title:
        "Mention the base year for calculation and the statement mentioning why?",
      type: "text",
      letter: "c.",
    },
    {
      fieldName: "reductionScope",
      title: "Scope in which reductions took place.",
      type: "checkbox",
      letter: "d.",
      options: ["Scope 1", "Scope 2", "Scope 3"],
    },
    {
      fieldName: "calculationUsed",
      title:
        "What are the standards, methodologies, assumptions, and/or calculations used?",
      type: "text",
      letter: "e.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [tables, setTables] = useState([]);
  const [tables1, setTables1] = useState([]);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI300`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 = res?.data?.data?.GRI300?.reduction;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    // Ensure formData?.includedGHGEmissions is always an array
    setFormData({
      baseYear: data?.baseYear || "",
      calculationUsed: data?.calculationUsed || "",
      reductionScope: Array.isArray(data?.reductionScope)
        ? data?.reductionScope
        : [], // If data is not an array, initialize as an empty array
    });
  }, [data]);

  const handleChange = (fieldName, value, type, checked) => {
    if (type === "number" && !validateNumber(value)) return;

    setFormData((prev) => {
      if (fieldName === "reductionScope") {
        let newGHGEmissions = [...prev[fieldName]]; // Copy the array to avoid mutation

        // If checkbox is checked, add the value to the array
        if (checked) {
          if (!newGHGEmissions.includes(value)) {
            newGHGEmissions.push(value);
          }
        } else {
          // If checkbox is unchecked, remove the value from the array
          newGHGEmissions = newGHGEmissions.filter((item) => item !== value);
        }

        // Return the updated state
        return {
          ...prev,
          [fieldName]: newGHGEmissions,
        };
      } else {
        // Handle other fields (non-checkbox)
        return {
          ...prev,
          [fieldName]: value,
        };
      }
    });
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (
        tables1?.[0]?.rows?.length > defaultSegments?.length &&
        !validateLastRow(inputData1, tables1, setTabErros)
      )
        return;
      let transformedData2 = {
        reduction: {
          ...restructureData(tables),
          ...restructureData(tables1),
          ...formData,
        },
        type: "GRI300",
        submitted305_5: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri300/305-6/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/305-6/${id}`);
    }
  };


  const renderContent = ({hide}) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && <p className={styles.section_heading}>305 : Emissions</p>}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1rem" : "1rem" }}>
        305-5 : REDUCTION OF GHG emissions{" "}
      </p>
      <StaticColumnTable
        {...{
          inputData,
          tables,
          setTables,
          errors: errors,
          setErrors: setErrors,
          data: data,
          defaultSegments: seg,
          defaultSegments2: seg2,
          parameter: "reductions",
          parameter2: "unit",
          disabled: disabled,
        }}
      />
      <Box sx={{ display: "flex", gap: 1, mt: hide ? "-1rem" : "1rem" , mb: hide ? "-1rem" : "0"  }}>
        <p className={styles.ques_heading}>
          b. Gases included in the calculation:
        </p>
        <p className={styles.ques_heading}>Tons</p>
      </Box>
      <DynamicStaticTable
        {...{
          inputData: inputData1,
          tables: tables1,
          setTables: setTables1,
          errors: tabErrors,
          setErrors: setTabErros,
          data: data,
          defaultSegments,
          parameter: "gasName",
          buttonHeading: "Add Other Gases",
          disabled: disabled,
          hide : hide
        }}
      />
      {questionData.map((el) => (
        <Box key={el.fieldName} sx={{ mt: hide ? "-1rem" : "0.5rem" }}>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <p className={styles.ques_heading}>{el.letter}</p>
            <p className={styles.ques_heading}>{el.title}</p>
          </Box>
          {el?.options ? (
            el?.options.map((option) => {
              console.log(
                "option",
                option,
                formData?.reductionScope,
                formData?.reductionScope?.includes(option)
              );
              return (
                <FormControlLabel
                  key={option}
                  sx={{ ml: 1, display: "flex", mt: "-0.5rem" }}
                  control={
                    <Checkbox
                      value={option}
                      onChange={(e) =>
                        handleChange(
                          el?.fieldName,
                          option,
                          el?.type,
                          e.target.checked
                        )
                      }
                      checked={
                        formData?.reductionScope?.includes(option) || false
                      } // Ensure it's always a boolean
                      disabled={disabled}
                    />
                  }
                  label={option}
                />
              );
            })
          ) : (
            <Box sx={{ ml: 2.5 }}>
              <InputField
                placeholder={"Enter Text"}
                fieldName={el.fieldName}
                value={formData?.[el.fieldName]}
                handleChange={(e) =>
                  handleChange(el?.fieldName, e.target.value, el?.type)
                }
                mt="-5px"
                errors={Boolean(errors[el.fieldName])}
                disabled={disabled}
              />
            </Box>
          )}
        </Box>
      ))}
     
    </>
  )

  return (
     <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
             {!griReview ? (
        <Box sx={{ ml: "1rem", width: "98%" }}>
          <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
        </Box>
      ) : (
        <Box textAlign="right" sx={{ mt: 3 }}>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
          >
            Save & Continue <EastIcon sx={{ ml: 2 }} />
          </Button>
        </Box>
      )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI305_5;
